import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-webinars',
  templateUrl: './webinars.component.html',
  styleUrls: ['./webinars.component.scss']
})
export class WebinarsComponent implements OnInit {

  webinarsList: any[] = [{
    title: "MSCI Factor Investing Webinar Series",
    author: "Anna Aston - MSCI",
    abstract: "Factor investing has brought disruptive change to the asset management industry. The effects were first felt in equities, but Factor investing is now going multi-asset class. Factor-based asset allocation and systematic strategy factors are starting to push beyond equity selection. The next webinar in our Factor Investing series will highlight our latest Factor Innovation, the MSCI Multi-Asset Class Factor Model, which helps investors more clearly identify the drivers of risk and return in these complex, dynamic strategies.",
    date: "Jan 29, 2020 4:00 p.m. BST London - Webex"
  }, {
    title: "Getting started with Factor Investing",
    author: "Anna Aston - BlackRock",
    abstract: "In our 30-minute session, we’ll examine how factors have historically driven returns across asset classes, how to use factors to seek resilience, and simple ways to explain them to your clients.",
    date: "Apr 30, 2020 4:00 p.m. BST London - Webex"
  }, {
    title: "Eliminate the noise of “off-target” exposure‎",
    author: "Anna Aston - FTSE",
    abstract: "The new FTSE Target Exposure Indexes are a suite of benchmarks designed to focus on specific characteristics— such as factor, climate and ESG exposures—while minimizing all off-target, consequential exposures, to deliver a “near pure” index. Target exposures are completely flexible and can be combined to cater to specific client objectives and investment outcomes.",
    date: "May 27, 2020 4:00 p.m. BST London - Webex"
  }];

  constructor() { }

  ngOnInit(): void {
  }

  showResourcesSlide(index: number) {
    //TODO: This function should control the carousel
    // of the Sharing Knowledge section.
  }
}
